<template>
  <v-layout row justify-center>
    <v-dialog
      persistent
      v-model="show_modal"
      scrollable
      max-width="400px"
    >
      <div class="faccess_modal">
        <div
          class="faccess_modal__header"
          :style="{backgroundColor: background}"
          style="color: #FFFFFF"
        >
          <p class="faccess_modal__header--title">
            {{location_name}}
          </p>
        </div>
        <div class="faccess_modal__body">
          <vue-qrcode id="qrcode" class="qr_code" :value="qr_text"></vue-qrcode>
        </div>
        <div class="faccess_modal__footer">
          <v-btn color="grey lighten-1" flat @click.native="closeModal()">Cerrar</v-btn>
        </div>
      </div>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props:{
    qr_text: {
      type: String
    },
    location_name: {
      type: String
    },
    background: {
      type: String,
      default: 'rgb(31, 202, 47)'
    }
  },
  data(){
    return{
      show_modal: true
    }
  },
  methods:{
    closeModal(){
      this.$emit('closeQrModal', false)
    }
  }
}
</script>

<style scoped>
  #qrcode{
      display: flex !important;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/QrModal.vue